import styled from 'styled-components'
import { mildGray, blue, inputShadow, softGray } from '../../styles/variables'
import { fieldLabel } from '../../styles/common'

const Input = styled.div`
  position: relative;
  padding: 10px 0 20px;
  display: flex;
  flex-direction: column;
  min-width: ${({ minWidth }) => minWidth ? minWidth : '250px'};
  max-width: ${({ minWidth }) => minWidth ? minWidth : 'auto'};

  ${({ fullWidth }) => fullWidth ? `
    min-width: 100%;
    width: 100%;
  ` : '' }


  ${fieldLabel}

  input {
    padding: 4px 8px;
    background: white;
    border: none;
    outline: none;
    font-size: 16px;
    flex: 1 1;
    caret-color: ${blue};
    &:disabled {
      opacity: 0.5;
    }
    max-width: 100%;
    box-sizing: border-box;
  }
`

const InputContainer = styled.div`
  background: white;
  box-shadow: ${inputShadow};
  display: flex;
  flex-direction: row;
  min-height: 34px;
  border: 1px solid white;

  ${({ inverted }) => inverted ? `
    background: ${softGray};
    border: 1px solid ${softGray};
    & > input {
      background: ${softGray};
    }
  ` : ''}

  ${({ error }) => error ? `
    border: 1px solid red !important;
  ` : ''}
`

const Icon = styled.div`
  cursor: pointer;
  transition: all .1s ease-in-out;
  color: ${mildGray};
  padding: 4px;
  font-size: 22px;

  &:hover {
    transform: scale(1.1);
    color: black;
  }
`

const ErrorLabel = styled.label`
  position: absolute;
  top: 66px;
  color: red !important;
  margin-top: 4px;
`

export default {
  Input,
  InputContainer,
  Icon,
  ErrorLabel,
}
